import React from "react";
import BackSvg from './assets/back-arrow.svg';

import { BackButtonProps } from "./BackButton.types";

import "./BackButton.scss";

export const BackButton: React.FC<BackButtonProps> = ({ text='Back', onPress }) => {
  return(
    <button type={"button"} onClick={()=> onPress ? onPress() : null} className="back-button"><img style={{marginRight : 11.5}} src={BackSvg}/>{text}</button>
  )
};
